/* This file is auto-generated. Do not edit, use `npm run  */
export const multiselectStyles = `
    .multiselect-enabled { 
        filter: grayscale(80%); 
    }

    .blocklyMenuItem:has(> .blocklyMenuItemContent > hr.ms-menuitem-separator) {
        padding: 0px;
    }

    .blocklyMenuItemContent:has(> hr.ms-menuitem-separator) {
        padding: 0px;
    }

    .ms-menuitem {
        /*background-color: #39f;*/
    }`;



